import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";

@Component({
  selector: "app-revenue-comparison-table-skeleton",
  imports: [CommonModule, SkeletonModule, TableModule],
  templateUrl: "./revenue-comparison-table-skeleton.component.html",
  styleUrl: "./revenue-comparison-table-skeleton.component.scss",
})
export class RevenueComparisonTableSkeletonComponent {
  // Mock data for skeleton rows
  skeletonRows = [
    { metric: "Revenue" },
    { metric: "Orders" },
    { metric: "AOV" },
  ];
}
